//import your css files here 
import "./src/styles/global.css"
import "bootstrap/dist/css/bootstrap.min.css"
import 'jquery/dist/jquery.min.js'
import 'popper.js/dist/popper.min'
import 'bootstrap/dist/js/bootstrap.min.js'
// or:
// require('./src/styles/global.css')